export const accountEmailErrorIndicator = {
    show: () => {
        jQuery(".account_email_error").show();
    },

    hide: () => {
        jQuery(".account_email_error").hide();
    },
};

export const accountEmailDisabledErrorIndicator = {
    show: () => {
        jQuery(".account_email_disabled_error").show();
    },

    hide: () => {
        jQuery(".account_email_disabled_error").hide();
    },
};

